import { HttpResult } from 'widgets-for-react'
import { RelatedContent } from './relatedContentBlockState'
import { RelatedContentFilter } from './relatedContentBlockWidget'

type RelatedContentData = {
  EventDate: string | null
  ContentType: 'News page' | 'Agenda event page'
  HeaderImage: string
  HeaderTitle: string
  Title: string
  Path: string
  TeaserDescription: string
}[]

export const relatedContentBlockApi = async (
  filter: RelatedContentFilter
): Promise<HttpResult<RelatedContent>> => {
  const res = await fetch(
    `/api/v1/pages/newsandevents/filter?${
      filter.source === 'department' ? `department=${filter.department}&` : ''
    }${
      filter.source === 'specialist' ? `specialist=${filter.specialist}&` : ''
    }${
      filter.source === 'tags'
        ? filter.tags.map((tagId) => `tags=${tagId}`).join('&')
        : ''
    }&pageSize=3`
  )

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: RelatedContentData = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: data.map((item) => ({
      type: item.ContentType === 'News page' ? 'news' : 'event',
      title: item.Title,
      headerTitle: item.HeaderTitle,
      intro: item.TeaserDescription,
      image: item.HeaderImage,
      slug: item.Path,
      eventDate: item.EventDate || undefined,
    })),
  }
}
